export const ErrorCodes = {
  AUTHENTICATION: 'SEC000',
  AUTHORIZATION: 'SEC001',
  NOT_FOUND: 'NFD001',
  UNHANDLED_EXCEPTION: 'SYS000',
  SERVICE_UNAVAILABLE: 'SYS001',
  VALIDATION: 'VAL000',
}
